// extracted by css-extract-rspack-plugin
module.exports =  {"button":"NumberInput-DYOL__button","number-input-custom-buttons":"NumberInput-SZ6v__number-input-custom-buttons"};